import { trim, get } from "lodash";
export var isSameEntityPath = function isSameEntityPath(entity1, entity2) {
  var path1 = trim(get(entity1, 'path', ''), '/');
  var path2 = trim(get(entity2, 'path', ''), '/');
  return !!(path1 && path2 && path1 === path2);
};